(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kele-pieles"] && !Shopify.designMode) return;
  try {
    
  // Cambiar de piel es mover UN atributo: data-activo. Las fronteras del corte,
  // que nombre se ve oscuro y que descripcion aparece cuelgan todos de el en el
  // CSS. Sin JS la seccion se queda en la primera piel, que es un estado
  // valido: se ve el recuadro, su nombre y su descripcion.
  (function () {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('.kele-pieles .kp3-capa, .kele-pieles .kp3-tab');
      if (!b) return;
      var mob = b.closest('.kp3-mob');
      if (!mob) return;
      var i = b.getAttribute('data-i');
      mob.setAttribute('data-activo', i);
      mob.querySelectorAll('.kp3-capa').forEach(function (c) {
        c.setAttribute('aria-pressed', c.getAttribute('data-i') === i ? 'true' : 'false');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
